export const BLANK: Record<string, unknown> = Object.freeze(Object.create(null));
export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ARRAY = Object.freeze([]);
